<template>
  <div class="item">
    <div class="cell no">{{ no }}</div>
    <div class="cell subject">{{ item.name }} ({{ tradeType === 'SELL' ? item.stampAmount : item.takeAmount }}/{{ item.maxAmount }})</div>
    <div class="cell pay"><span class="gold">{{ numberToString(item.amount) }}</span></div>
    <div class="cell user">
      <div class="user">
        <span class="_device">등록자</span>
        <img class="level" :src="'/refer/img/level/lv'+item.level+'.png'" :alt="item.nickname" :title="item.nickname"/>
        <a class="nick" href="javascript:;" v-on:click="popupNickname(item.nickname)" :title="item.nickname">{{item.nickname }}</a>
      </div>
    </div>
    <div v-if="status === 'my'" class="cell user">
      <div v-if="item.targetNickname" class="user">
        <span class="_device">{{ tradeType === 'SELL' ? '구매자' : '판매자' }}</span>
        <img class="level" :src="'/refer/img/level/lv'+item.targetLevel+'.png'" :alt="item.targetNickname" :title="item.targetNickname"/>
        <a class="nick" href="javascript:;" v-on:click="popupNickname(item.targetNickname)" :title="item.targetNickname">{{ item.targetNickname }}</a>
      </div>
      <span v-else class="empty">-</span>
    </div>
    <div class="cell date">{{ item.regDt }}</div>
    <div class="cell option">
      <button class="btn btn_bs" v-if="item.status === 1 && item.isMine === false" v-on:click="tradeItem">
        {{ this.item.tradeType === 'SELL' ? '구매하기' : '판매하기' }}
      </button>
      <button class="btn btn_cancel" v-else-if="item.status === 1 && item.isMine === true" v-on:click="tradeItem">
        취소하기
      </button>
      <span v-if="item.status === 2">판매완료</span>
      <span v-if="item.status === 3">취소완료</span>
    </div>
  </div>
</template>

<script>
  import common from '../../mixins/common';

  export default {
    name: "trade-item",
    mixins: [
      common
    ],
    props: [
      "item",
      "no",
      "status"
    ],
    data() {
      return {
        loaded: true
      }
    },
    methods: {
      tradeItem() {
        $('._layer_background').show();
        this.$eventBus.$emit("openTradePopop", this.item);
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/store/trade-item.vue